import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-md-12 container-fluid bg-white rounded shadow mt-3 p-3 text-start" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "รายการหมวดหมู่", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-plus" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "เพิ่มหมวดหมู่", -1)
const _hoisted_7 = { class: "col-md-6 mt-3" }
const _hoisted_8 = { class: "input-group w-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "table mt-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "หมวดหมู่"),
    /*#__PURE__*/_createElementVNode("th", null, "...")
  ])
], -1)
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen my-icon" }, null, -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "class fa-solid fa-trash my-icon" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { "aria-label": "Page navigation example" }
const _hoisted_19 = { class: "pagination" }
const _hoisted_20 = { class: "page-item" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: "btn btn-primary rounded-pill text-white px-4",
          to: "/portal/category/create"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: "ค้นหาด้วยชื่อ",
            "aria-describedby": "button-addon1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event))
          }, null, 512), [
            [_vModelText, _ctx.search]
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            id: "button-addon1",
            type: "button",
            "data-mdb-ripple-color": "dark",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchData()))
          }, _hoisted_10)
        ])
      ]),
      _createElementVNode("table", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (item, index) => {
          return (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString((index+1)+(_ctx.page-1)*_ctx.show), 1),
              _createElementVNode("td", null, _toDisplayString(item.nameTH), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  class: "btn btn-warning btn-circle btn-sm me-2",
                  rel: "tooltip",
                  to: `/portal/category/edit/${item._id}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("button", {
                  class: "btn btn-danger btn-circle btn-sm",
                  type: "button",
                  rel: "tooltip",
                  onClick: ($event: any) => (_ctx.deleteData(item._id))
                }, _hoisted_17, 8, _hoisted_15)
              ])
            ])
          ]))
        }), 256))
      ]),
      _createElementVNode("nav", _hoisted_18, [
        _createElementVNode("ul", _hoisted_19, [
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePaginate(_ctx.page-1)))
            }, "ก่อนหน้า")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginate, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (index>_ctx.page-_ctx.limit&&index<_ctx.page+_ctx.limit)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass(["page-item", {'active':(index==(_ctx.page-1))}])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: ($event: any) => (_ctx.updatePaginate(index+1))
                    }, _toDisplayString(index+1), 9, _hoisted_21)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          _createElementVNode("li", _hoisted_22, [
            (_ctx.page!=_ctx.pages)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "page-link",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePaginate(_ctx.page+1)))
                }, " ถัดไป"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}